export default __webpack_public_path__ + "static/media/549.36544d97.png";